/**
 * Global gtag.js events
 *
 * Send custom events for interactions in the global page header (#top) and footer (#footer)
 */

class GtagGlobalEvents {
    constructor() {
        if (typeof window.gtag !== 'undefined') {

            // click on elements
            let clickElms = document.querySelectorAll('#top [data-gtag-click], #footer [data-gtag-click]');
            clickElms.forEach((elm) => {
                elm.addEventListener('click', (e) => {
                    let params = {};
                    if (elm.dataset.gtagParams) {
                        params = JSON.parse(elm.dataset.gtagParams) ?? null;
                    }
                    window.gtag('event', elm.dataset.gtagClick, params);
                }, { passive: true });
            });

            // click on links inside a container
            let groupElms = document.querySelectorAll('#top [data-gtag-click-links], #footer [data-gtag-click-links]');
            groupElms.forEach((groupElm) => {
                let params = JSON.parse(groupElm.dataset.gtagParams) ?? {};
                let gtagEvent = groupElm.dataset.gtagClickLinks;
                let clickElms = groupElm.querySelectorAll('a:not([data-gtag="false"])');
                clickElms.forEach((elm) => {
                    elm.addEventListener('click', (e) => {
                        let anchorDefaults = {
                            linkUrl: elm.getAttribute('href'),
                            linkText: elm.textContent.replace(/[\n\r]+|\s{2,}/g, ' ').trim(),
                        };
                        let anchorParams = {};
                        if (elm.dataset.gtagParams) {
                            anchorParams = JSON.parse(elm.dataset.gtagParams) ?? {};
                        }
                        window.gtag('event', gtagEvent, { ...params, ...anchorDefaults, ...anchorParams });
                    }, { passive: true });
                });
            });
        }
    }
}

export default GtagGlobalEvents;